import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Image from '@divvy-web/skylab.image'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import styles from './styles.module.scss'

export interface BasePageLayoutProps {
  marketingImage: {
    alt: string
    src: string
  }
  footer: React.ReactNode
}

const BasePageLayout = ({
  marketingImage: { src, alt },
  footer,
  children,
}: React.PropsWithChildren<BasePageLayoutProps>) => {
  const [getClassName] = useNameFormatter('BasePageLayout')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('wrapper')]}>
        <BillBrandLogo />
        <div className={styles[getClassName('content-container')]}>
          <div className={styles[getClassName('content')]}>{children}</div>
        </div>
        <div className={styles[getClassName('footer')]}>{footer}</div>
      </div>
      <div className={styles[getClassName('marketing')]}>
        <div className={styles[getClassName('image-wrapper')]}>
          <Image
            alt={alt}
            className={styles[getClassName('image')]}
            src={src}
          />
        </div>
      </div>
    </div>
  )
}

export default BasePageLayout
